import { Lightning as lng } from '@lightningjs/sdk';
import { MiniEpgCardsContainer } from './MiniEpgCardsContainer';
import { Theme } from '../../../config/theme';
import { MiniEpgDataSource } from '../../../Business/epg/MiniEpgDataSource';
import { MiniEpgChannelSelector } from './MiniEpgChannelSelector';
import { debounced } from '../../../Business/utility/Debounced';

export const _constants = {
  channelLocation: 478,
  channelsWidth: 410,
  cardWidth: 420,
  cardHeight: 327,
  height: 380,
  hSpacing: 28,
};

export class MiniEpg extends lng.Component {
  static _template() {
    return {
      w: w => w,
      h: h => h,
      BottomBackground: {
        w: w => w,
        h: h => h,
        rect: true,
        colorTop: Theme.Colors.Transparent,
        colorBottom: Theme.Colors.CmsZappingBar.Background,
      },
      CardsContainer: {
        w: w => w,
        h: h => h,
        type: MiniEpgCardsContainer,
      },
      ChannelContainer: {
        x: _constants.channelLocation,
        h: h => h,
        w: _constants.channelsWidth,
        type: MiniEpgChannelSelector,
        signals: {
          loadNewChannel: true,
        },
      },
    };
  }

  _init() {
    this._cardsContainer = this.tag('ChannelCardsContainer');
    this.prevTime = 0;
    this._params = undefined;
  }

  _focus() {
    // this.tag('ChannelCardsContainer').setSmooth('x', 0);
    // this.tag('SelectorIcon').setSmooth('x', 0);
    // this.tag('TopBackground').setSmooth('y', 0);
    // this.tag('BottomBackground').setSmooth('y', 1080);
  }

  _unfocus() {
    // this.tag('ChannelCardsContainer').setSmooth('x', -_constants.zappingBarWidth);
    // this.tag('SelectorIcon').setSmooth('x', -_constants.zappingBarWidth);
    // this.tag('TopBackground').setSmooth('y', -_constants.backgroundHeight);
    // this.tag('BottomBackground').setSmooth('y', 1080 + _constants.backgroundHeight);
  }

  _handleDown() {
    this.tag('ChannelContainer')._handleDown();
    return false;
  }

  _handleUp() {
    this.tag('ChannelContainer')._handleUp();
    return false;
  }

  _handleLeft() {
    this.tag('CardsContainer').moveRight();
    return false;
  }

  _handleRight() {
    this.tag('CardsContainer').moveLeft();
    return false;
  }

  _getFocused() {
    return this.tag('CardsContainer');
  }

  _active() {
    this.tag('CardsContainer').alpha = 0.0001;
    if (this._dataSource) {
      this._dataSource.initialize().then(validChan => {
        // set channel data to channelSelector. in channel sel check if different or not
        this.tag('ChannelContainer').channels = validChan;
        // get id of current stream
        const currentChannelId =
          this._backend.playerController.streamManager._currentStreamInfo._epgEvent.channel.channelId;
        // set chann selector to this id
        this.tag('ChannelContainer').currentChannel = currentChannelId;

        // load cards of this channel
        this._dataSource.loadCardSchedules(currentChannelId).then(r => {
          // console.log('loaded and created card Dses:', r);
          this.tag('CardsContainer').schedules = r;
          this.tag('CardsContainer').setSmooth('alpha', 1);
        });
      });
    }
  }

  loadNewChannel(channelId) {
    this.tag('CardsContainer').setSmooth('alpha', 0.0001);
    this.tag('CardsContainer').clearImages();
    if (this._dataSource) {
      if (!this._debouncedUpdate) {
        this._debouncedUpdate = debounced(_channelId => {
          this._dataSource.initialize().then(() => {
            // load cards of this channel
            this._dataSource.loadCardSchedules(_channelId).then(r => {
              // console.log('loaded and created new channel card Dses:', r);
              this.tag('CardsContainer').schedules = r;
              this.tag('CardsContainer').setSmooth('alpha', 1);
            });
          });
        }, 300);
      }

      this._debouncedUpdate(channelId);
    }
  }

  _handleEnter() {
    // activate changeStream function in PlayerPage
    // if (!this.switchingChUpChDown) {
    //   this.fireAncestors('$changeStream', this._cardsContainer.children[5].channelModel);
    // } else {
    //   this._owner._overlayHelper.onStart();
    // }
  }

  set backend(back) {
    this._backend = back;
    this.tag('ChannelContainer').backend = back;
    this._dataSource = new MiniEpgDataSource(back);
  }
}
